import { render } from "./NotifCmp.vue?vue&type=template&id=37480cb6"
import script from "./NotifCmp.vue?vue&type=script&lang=js"
export * from "./NotifCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__